import React from 'react';

export const useIsMounting = () => {
  const [isMounting, setIsMounting] = React.useState(true);
  React.useEffect(() => setIsMounting(false), []);
  return isMounting;
};
